import * as ERRORS from 'Reducers/Errors/const'

/**
 * Push new API error to the top of api error list
 *
 * @param error
 * @returns {{type, error: *}}
 */
export function pushApiError(error) {
  return {
    type: ERRORS.PUSH_API_ERROR,
    error,
  }
}

/**
 * Remove oldest API error
 *
 * @returns {{type}}
 */
export function removeOldestApiError() {
  return {
    type: ERRORS.REMOVE_OLDEST_API_ERROR,
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Errors/actions.js